// const Path = "http://localhost:3000";
const Path = "https://datamgr.mhme.nu";

function analyze(data) {
    return fetch(`${Path}/pdf/analyze`, {
        method: 'post',
        body: data,
        mode: "cors"
    })
}

function status() {
    return fetch(`${Path}/status`, {mode: 'cors'});
}
function getPopMenuItems(path) {
    return fetch(`${Path}/pop/menu?path=${encodeURIComponent(path)}`, {mode: 'cors'});
}

function getPdfItems(pages, matches) {
    const sections = [{
        name: "Section",
        items: []
    }];
    let active = {
        name: "",
        price: [],
        description: ""
    };

    pages.forEach(content => {
        content.items.forEach(item => {
            if (!item.str || !item.str.trim()) return;

            if (item.str == parseFloat(item.str)) {
                active.price.push(item.str);
                return;
            }

            if (matches.find(match => match.font === item.fontName).type === "Item name") {
                if (active.name) {
                    sections[0].items.push(active);
                }
                active = { name: item.str, price: [], description: ""}
            }

            if (matches.find(match => match.font === item.fontName).type === "Item description") {
                active.description += item.str;
            }
        });
    });

    return sections;
}

export default {
    status,
    analyze,
    getPdfItems,
    getPopMenuItems
}
